import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Input from '../ui/Input';
import Button from '../ui/Button';

const MarketplaceHeader = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const navigationItems = [
  { label: 'Home', path: '/service-catalog-home', icon: 'Home' },
  { label: 'Browse Services', path: '/service-category-browse', icon: 'Grid3x3' },
  { label: 'About Us', path: '/about-ebas-venture', icon: 'Building2' }];


  const isActivePath = (path) => location?.pathname === path;

  const handleSearch = (e) => {
    e?.preventDefault();
    console.log('Searching for:', searchQuery);
  };

  return (
    <>
      <header className="marketplace-header">
        <div className="marketplace-header-container">
          <Link to="/service-catalog-home" className="marketplace-logo">
            <img
              src="/assets/images/200x68-1775706855169.jpg"
              alt="OTAssist by OBAS Private Limited Logo"
              className="h-20 w-auto object-contain" />

          </Link>

          <form onSubmit={handleSearch} className="marketplace-search">
            <Input
              type="search"
              placeholder="Search 2000+ services..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full" />

          </form>

          <nav className="marketplace-nav">
            {navigationItems?.map((item) =>
            <Link
              key={item?.path}
              to={item?.path}
              className={`marketplace-nav-link ${isActivePath(item?.path) ? 'active' : ''}`}>

                <Icon name={item?.icon} size={18} className="inline mr-2" />
                {item?.label}
              </Link>
            )}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link to="/admin-secure-login-portal">
              <Button variant="outline" size="sm">
                <Icon name="Shield" size={16} className="mr-2 text-red-600" />
                Admin Login
              </Button>
            </Link>
          </div>

          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu">

            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </Button>
        </div>
      </header>
      <div className={`marketplace-mobile-menu ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <div className="p-6 space-y-4">
          <div className="flex items-center justify-between mb-6">
            <span className="text-xl font-semibold font-heading">Menu</span>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu">

              <Icon name="X" size={24} />
            </Button>
          </div>

          <form onSubmit={handleSearch} className="mb-6">
            <Input
              type="search"
              placeholder="Search services..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)} />

          </form>

          <nav className="space-y-2">
            {navigationItems?.map((item) =>
            <Link
              key={item?.path}
              to={item?.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-250 ${
              isActivePath(item?.path) ?
              'bg-primary text-primary-foreground' :
              'text-foreground hover:bg-muted'}`
              }
              onClick={() => setIsMobileMenuOpen(false)}>

                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </Link>
            )}
          </nav>

          <div className="mt-6 pt-6 border-t border-border">
            <Link to="/admin-secure-login-portal" onClick={() => setIsMobileMenuOpen(false)}>
              <Button variant="outline" className="w-full">
                <Icon name="Shield" size={18} className="mr-2 text-red-600" />
                Admin Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>);

};

export default MarketplaceHeader;